<template>
  <v-container
    class="py-10"
    style="background-color: #ecf1f8;"
  >
    <!-- Company row -->
    <v-row
      v-if="coach.profile.company && Object.entries(coach.profile.company).length"
      class="px-8"
    >
      <!-- Contact Email -->
      <v-col
        v-if="coach.profile.company.email"
        class="py-1 d-flex"
        :cols="12"
        :sm="6"
      >
        <span
          class="mr-3"
          style="width: 27px; text-align: center;"
        >
          <v-icon
            color="primary"
            size="25"
          >
            email
          </v-icon>
        </span>
        <a
          class="linkHighlight subtitle-2 font-weight-regular"
          :href="`mailto:${coach.profile.company.email}`"
        ><span class="brandFont fiveHundred">{{ coach.profile.company.email }}</span></a>
      </v-col>

      <!-- Contact telephone -->
      <v-col
        v-if="coach.profile.company.telephone"
        class="py-1"
        :cols="12"
        :sm="6"
      >
        <v-icon
          class="mr-3"
          color="primary"
          size="25"
        >
          phone
        </v-icon>
        <span class="subtitle-2 font-weight-regular">
          <span class="brandFont fiveHundred">{{ coach.profile.company.telephone }}</span>
        </span>
      </v-col>

      <!-- Linkedin link -->
      <v-col
        v-if="coach.profile.linkedin_url"
        class="py-1"
        :cols="12"
        :sm="6"
      >
        <v-icon
          class="mr-3"
          color="primary"
          size="26"
        >
          mdi-linkedin
        </v-icon>
        <a
          class="linkHighlight subtitle-2 font-weight-regular"
          :href="coach.profile.linkedin_url"
          target="_blank"
        ><span class="brandFont fiveHundred">{{ coach.profile.linkedin_url }}</span></a>
      </v-col>

      <!-- Company Website -->
      <v-col
        v-if="coach.profile.company.website"
        class="py-1"
        :cols="12"
        :sm="6"
      >
        <v-icon
          class="mr-3"
          color="primary"
          size="27"
        >
          home
        </v-icon>
        <a
          class="linkHighlight subtitle-2 font-weight-regular"
          :href="coach.profile.company.website"
          target="_blank"
        ><span class="brandFont fiveHundred">{{ coach.profile.company.website }}</span></a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SectionSubInfo',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedCompany() {
      const company = [];
      let keys = [];
      const sortIndex = {
        name: 0,
        email: 1,
        telephone: 2,
        website: 3,
        address: 4,
      };

      if (this.coach.profile.company) {
        keys = Object.keys(this.coach.profile.company);
        keys.sort((a, b) => sortIndex[a] - sortIndex[b]);

        keys.forEach((key) => {
          if (this.coach.profile.company[key]) {
            company.push({
              key: `${key.charAt(0).toUpperCase()}${key.slice(1)}`,
              value: this.coach.profile.company[key],
            });
          }
        });
      }

      return company;
    },
  },
};
</script>

<style lang="scss" scoped>
  // Set custom A tag color
  .linkHighlight {
    color: #000000;

    &:hover {
      color: #3c3c3c;
      text-decoration: underline;
    }
  }
</style>
